import React from 'react';
import './Footer.css';
import {IoMdCall} from 'react-icons/io'
import { Link } from 'react-router-dom';



const Footer = () => {
  return (

    // start
    <div className='mt-[70px] footerShadow z-10  dark:bg-gradient-to-r from-[#0E1629] via-[#0D1425] to-[#0B1120]'>
      <footer className="footer p-10 text-black footer-style border-t dark:border-[#23293a] grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4" >
        <div className='lg:mx-auto dark:text-slate-200' >
          <span className=" footer-title" > Services</span >
          <p className="#" > Reading</p >
          <p className="link link-hover" > Writing</p >
          <p className="link link-hover" > Assignment</p >
          <p className="link link-hover" > Marks</p >
        </div >
        <div className='lg:mx-auto dark:text-slate-200' >
          <span className="footer-title" > Teacher</span >
          <p className="link link-hover" > Mozahid </p >
          <p className="link link-hover" > Masud Rana</p >
          <p className="link link-hover" > Rana Akash</p >
          <p className="link link-hover" > Hridoy Ahmmed</p >
        </div >
        <div className='lg:mx-auto dark:text-slate-200' >
          <span className="footer-title" > Resource</span >
          <p className="link link-hover" > Google </p >
          <p className="link link-hover" > LinkedIn</p >
          <p className="link link-hover" > Facebook</p >
          <p className="link link-hover" > Library</p >
        </div >
        <div className='dark:text-slate-200 lg:mx-auto' >
          <span className="footer-title" >Our Social Site</span >
          <div className="flex">
            <img className='w-8' src='https://i.ibb.co/rm75LRs/fb-1.png' alt="" />
            <img className='w-8 ml-5' src="https://i.ibb.co/pbNV4Hh/instragram.png" alt="" />
            <img className='w-8 ml-5' src="https://i.ibb.co/ZcRmNQB/youtube.png" alt="" />
          </div>
          <span className='flex mt-3'><IoMdCall/> <span className='ml-2'>+0080159931945</span></span>
          <Link to='/contact'>Contact Us</Link>
        </div >


      </footer >
      <div>
        <p className='text-center font-bold text-[#0a08089c] dark:text-slate-200 py-5'>&copy; All rights reserved 2023</p>
      </div >
    </div >
  );
};

export default Footer;